import sha256 from 'hash.js/lib/hash/sha/256';

/**
 * Produces a SHA256 hash of the given string.
 * Assets that update different parts of their payload separately can use
 * hashes, ids and other types of validation to detect inconsistencies in the payload.
 */
export default function getHashCode(value: string | null | undefined) {
    return sha256().update(value).digest('hex');
}
